// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3e6D2","description":"PatientConsentPreview_description__1ePSB"};